<template>
  <div class="empty-list">
    暂无数据
  </div>
</template>

<script>
export default {
  name: 'EmptyCard',
}
</script>

<style lang="scss" scoped>
.empty-list {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 16px;
}
</style>
